import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocalizedString } from "@amzn/aws-marketing-identity-kit-localizations";
import Badge from "../base/Badge";
function VisibleToOthersBadge() {
    const { t } = useLocalizedString();
    return (_jsx(_Fragment, { children: _jsx(Badge, { text: t("Visible to others"), tooltipText: t("Fields in this section will be visible to others.") }) }));
}
export default VisibleToOthersBadge;
//# sourceMappingURL=VisibleToOthersBadge.js.map